import React from 'react';
import PropTypes from 'prop-types';
import { validatePassword } from '../../../../helpers/validation';
import { PASSWORD_REQUIREMENTS } from '../../../../constants/Copy';

import './PasswordStrengthCheck.scss';

const PasswordStrengthCheck = ({ password, showErrors }) => {
	const { USE_AT_LEAST, UPPER_CASE_LETTERS, LOWER_CASE_LETTERS, MIN_CHARACTERS } =
		PASSWORD_REQUIREMENTS;

	const { errors } = validatePassword({ password });
	const { minLength, minCapital, minLowercase } = errors;

	const validationElement = (requirement, text) => {
		const className = `validation-status validation-status--${
			requirement ? 'valid' : password && showErrors ? 'invalid' : 'pending'
		}`;
		return <div className={className}>{text}</div>;
	};

	return (
		<span className="onboarding-password-strength-check">
			<div>
				{USE_AT_LEAST}:{validationElement(minCapital, UPPER_CASE_LETTERS)}
				{validationElement(minLowercase, LOWER_CASE_LETTERS)}
				{validationElement(minLength, MIN_CHARACTERS)}
			</div>
		</span>
	);
};

PasswordStrengthCheck.propTypes = {
	password: PropTypes.string,
};

export default PasswordStrengthCheck;
